import { publishMessage } from "../notification/notificationActions";
import * as cityActionTypes from "./cityActionTypes";
import * as message from "../../message";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import Axios from "axios";
import { baseUrl } from "../../util/host";

export const setCityList = (cities) => {
  return {
    type: cityActionTypes.LOAD_CITY,
    value: cities,
  };
};

export const setDeliveryList = (deliveries) => {
  return {
    type: cityActionTypes.LOAD_DELIVERY_OPTIONS,
    value: deliveries,
  };
};

export const clearCity = () => {
  return {
    type: cityActionTypes.CLEAR_CITY,
  };
};

export const loadCity = (country, provinceId) => {
  const warehouse = localStorage.getItem("warehouse");
  const payload = { country: country, provinceId, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/find/city`, payload)
      .then((res) => {
        dispatch(setCityList(res.data.response));
        dispatch(setDeliveryList(res.data.deliveryOption))
        dispatch(
          publishMessage({
            message: message.LOAD_CITY,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        dispatch(clearCity());
        dispatch(hideSpinner());
        console.log(err);
      });
  };
};

export const updateCity = (city) => {
  const country = localStorage.getItem("country");
  const provinceId = localStorage.getItem("provinceId");
  const warehouse = localStorage.getItem("warehouse");

  const payload = { objkey: country, country, provinceId, city, warehouse };
  city.holiday = Array.isArray(city.holiday) ? city.holiday.join(",") : city.holiday;
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.put(`${baseUrl("REACT_APP_API_URL")}/api/address/city`, payload)
      .then((res) => {
        dispatch(loadCity(country, provinceId));
        dispatch(
          publishMessage({
            message: message.UPDATE_CITY_SUCCESS,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        dispatch(hideSpinner());
        console.log(err);
      });
  };
};

export const addNewCity = (city) => {
  const country = localStorage.getItem("country");
  const provinceId = localStorage.getItem("provinceId");
  const warehouse = localStorage.getItem("warehouse");
  city.holiday = Array.isArray(city.holiday) ? city.holiday.join(",") : city.holiday;
  const payload = { objkey: country, country, provinceId, city, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/city`, payload)
      .then((res) => {
        dispatch(loadCity(country, provinceId));
        dispatch(
          publishMessage({
            message: message.UPDATE_CITY_SUCCESS,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        dispatch(hideSpinner());
        console.log(err);
      });
  };
};

export const setDefaultCity = (city) => {
  const country = localStorage.getItem("country");
  const payload = { country, city };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(
      `${baseUrl("REACT_APP_API_URL")}/api/address/default/city`,
      payload
    )
      .then((res) => {
        console.log(res);
        dispatch(
          publishMessage({
            message: message.DEFAULT_CITY,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        dispatch(hideSpinner());
      });
  };
};
